import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { Languages } from "types/localization";
import { getLocalStorageItem, setLocalStorageItem } from "utils/localStorage";
import { isAvailableLang } from "./is";

export const getInitLanguage = () => {
  const { search, href } = window.location;
  const query = new URLSearchParams(search);
  const paramLang = query.get(STORAGE_LANGUAGE_NAME)?.toUpperCase();
  const pathLang = href
    .match(/https?:\/\/[^\\/]+\/(?<lang>.+?)($|\/)/)
    ?.groups?.lang.toUpperCase();

  let currentLocale =
    getLocalStorageItem(STORAGE_LANGUAGE_NAME)?.toUpperCase() ||
    Languages.EN.toUpperCase();

  // Проставляем в приоритете ту что пришла в квери параметрах
  if (paramLang && isAvailableLang(paramLang)) {
    currentLocale = paramLang;
  }

  // Если квери параметра нету, ищу локаль в полном пути по группам
  if (pathLang && isAvailableLang(pathLang)) {
    currentLocale = pathLang;
  }

  setLocalStorageItem(STORAGE_LANGUAGE_NAME, currentLocale.toUpperCase());

  return currentLocale;
};
